import Component from '@glimmer/component';
import { action } from '@ember/object';

/**
 * @param {Array}               selectedItems
 * @param {Function}            userToggleChecked
 * @param {String}              inputClass
 * @param {Boolean}             isDisabled
 * @param {Object}              item
 */
export default class ListItemCheckbox extends Component {
  get isSelected() {
    return this.args.selectedItems.includes(this.args.item);
  }

  @action
  didClick(event) {
    this.args.userToggleChecked(this.args.item, event, event.target.checked);
  }
}
